import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "../../../../environments/environment";
import { CommonService } from "../common-service";
import { SearchBarResponse } from "../responses/orchestrator-search.response";

@Injectable({
  providedIn: 'root'
})
export class OrchestratorSearchService extends CommonService {

  constructor(
    private httpClient: HttpClient,
  ) {
    super();
  }

  public Search(request: string): Observable<SearchBarResponse> {
    return this.httpClient.get<SearchBarResponse>(environment.urlApiOrchestratorData + "PessoaSearchBar/searchText/" + request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
